import { createApi } from './core';
import { Claim } from './claims.types';

declare const healConfig: any;

function createClaimsApi() {
  return createApi({ baseURL: healConfig.apiBaseUrl });
}

// export function submitClaim(claimId: string): Promise<Claim> {
//   return createClaimsApi()
//     .then((api) => api.post<Claim>(`/insurance/v1/claim/${claimId}/submit`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

// export function refreshClaim(claimId: string): Promise<Claim> {
//   return createClaimsApi()
//     .then((api) => api.post<Claim>(`/insurance/v1/claim/${claimId}/refresh`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

export function refreshERA(claimId: string): Promise<Claim> {
  return createClaimsApi()
    .then((api) => api.post<Claim>(`/insurance/v1/claim/${claimId}/refresh?force=true&checkMechanism=PAYMENT_REPORT`))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
}

// export function resetClaim(claimId: string): Promise<Claim> {
//   return createClaimsApi()
//     .then((api) => api.post<Claim>(`/insurance/v1/claim/${claimId}/reset`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

export function cancelClaim(visitCode: string): Promise<Claim> {
  return createClaimsApi()
    .then((api) => api.post<Claim>(`/insurance/v1/claim/external_reference/${visitCode}/cancel`))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
}

// export function fetchPayers(): Promise<Payer[]> {
//   return createClaimsApi()
//     .then((api) => api.get<Payer[]>(`/insurance/v1/payer/`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

// export function fetchBillingProviders(): Promise<BillingProvider[]> {
//   return createClaimsApi()
//     .then((api) => api.get<BillingProvider[]>(`/insurance/v1/billing_provider/`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

// export function fetchClaimByID(claimID: string): Promise<Claim> {
//   return createClaimsApi()
//     .then((api) => api.get<Claim>(`/insurance/v1/claim/${claimID}`))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }

// export function updateClaimDetails(claim: Claim): Promise<Claim> {
//   return createClaimsApi()
//     .then((api) => api.put<Claim>(`/insurance/v1/claim/${claim.id}`, claim))
//     .then((r) => (r.ok && r.data ? r.data : Promise.reject(new Error((r.data as any).description))));
// }
